<template>
  <div v-loading="loading">
    <el-input
      v-model="config.servName"
      clearable=""
      style="margin-bottom:10px;"
      placeholder="请输入合作服务名称">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="fetch"></el-button>
    </el-input>
    <el-table
      :data="list"
      height="520px"
      border=""
      @row-click="selectitem">
      <el-table-column
        prop="servName"
        label="服务名称"
        min-width="240"></el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
  </div>
</template>
<script>
import OrgService from '@/service/org-service'
export default {
  name: 'ServiceInfo',
  props: {
    linkType: { type: Number, default: 260 }
  },
  data() {
    return { loading: false, list: [], total: 0, config: { servName: '', pageNum: 1, pageSize: 10, status: 1 }}
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetch() {
      this.config.pageNum = 1
      this.fetchList()
    },
    selectitem(item) {
      this.$emit('select', { linkType: this.linkType, link: item.id, title: item.servName })
    },
    fetchList() {
      this.loading = true
      OrgService.getservs({ ...this.config })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
